import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default function EmptySlot({ isChanging }: { isChanging: boolean }) {
  return (
    <div
      className={classnames(
        'equipped-group__equipped equipped-group__equipped--empty',
        isChanging && 'equipped-group__equipped--is-changing',
      )}
      style={{
        width: '40px',
        height: '40px',
      }}
    />
  );
}

EmptySlot.propTypes = {
  isChanging: PropTypes.bool.isRequired,
};